import { Dispatch } from 'redux';
import STORAGE_CONSTANTS from '../constants/storage.constants';
import { logoutAPIcall } from '../redux/actions/auth/auth.actions';
import { error, clear } from '../redux/actions/alert/alert.actions';
import { updateGlobalSpinner, updateLocalSpinner } from '../redux/actions/spinner/spinner.action';

const authFetch = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  url: string,
  method: string,
  body?: string | FormData,
  type?: string,
  showGlobalSpinner = true,
  showLocalSpinner = false,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const headers: any = {
    Authorization: `JWT ${localStorage.getItem(STORAGE_CONSTANTS.TOKEN_KEY)}`,
  };

  if (type !== undefined && type !== '') {
    // User defined type being sent
    headers['Content-Type'] = type;
  } else if (type !== undefined && type === '') {
    // Empty string denotes sending no content-type -- used for rootmedia uploads
  } else {
    // Otherwise all requests are application/json type
    headers['Content-Type'] = 'application/json';
  }

  // Show global spinner
  if (showGlobalSpinner) {
    dispatch(updateGlobalSpinner(true));
  }

  // Show local spinner
  if (showLocalSpinner) {
    dispatch(updateLocalSpinner(true));
  }

  let fixedUrl = url;
  // Check for trailing slash
  if (url[url.length - 1] !== '/') {
    fixedUrl = `${url}/`;
  }

  return fetch(fixedUrl, {
    method,
    headers,
    body,
  }).then((response) => {
    // Hide global spinner
    if (showGlobalSpinner) {
      dispatch(updateGlobalSpinner(false));
    }

    // Hide local spinner
    if (showLocalSpinner) {
      dispatch(updateLocalSpinner(false));
    }

    // Check for successful 204 w/ no body
    if (response.status === 204 || response.status === 201) {
      return Promise.resolve({});
    }

    // Check for success response w/ body
    if (response.ok) {
      return response.json();
    }

    // Check for 401/403 logout scenarios
    if (response.status === 401 || response.status === 403) {
      dispatch(logoutAPIcall(false));
      dispatch(error('An error has occurred. Please contact training@blueearthdxmedicalaffairshub.com.'));
      setTimeout(() => {
        dispatch(clear());
      }, 6000);
      throw Error('An error has occurred. Please contact training@blueearthdxmedicalaffairshub.com.');
    }

    // Otherwise check for errors
    return response.json().then((json) => {
      if (json.non_field_errors) {
        throw Error(json.non_field_errors[0]);
      } else if (json.error) {
        throw Error(json.error);
      } else if (json.errors) {
        throw Error(json.errors.slice(-1));
      } else {
        throw Error(response.statusText);
      }
    });
  });
};

export default authFetch;
